export const iconStyles = {
	header: {
		backgroundColor: '#1f3033',
	},
	sidebar: {
		backgroundColor: '#1f3033',
		color: 'white',
	},
	title: {
		color: 'white',
	},
	button: {
		backgroundColor: '#ed8222',
		color: '#fff',
		fontWeight: 600,
		':hover': {
			backgroundColor: '#0083be',
		},
	},
	text: {
		color: '#00305e',
		buttonLoadingColor: '#FFFFFF',
	},
	table: {
		headerBackgroundColor: '#0046AD',
		headerTextColor: '#ffffff',
	},
	platformName: {
		name: 'Icon Parking',
	},
	logo: {
		small: {
			src: '/icon/icon-parking-icon.svg',
			height: 35,
			width: 35,
		},
		large: {
			src: '/icon/icon-parking-logo.svg',
			height: 41,
			width: 75,
		},
	},
	favicon: {
		src: '/icon/icon-parking-icon.svg',
	},
	socials: {
		x: 'https://x.com/IconParkingNYC',
		facebook: 'https://www.facebook.com/IconParkingNYC',
	},
	siteUrl: 'https://iconparking.com/',
	orgName: 'Icon',
};
